import {
  SET_PAGE_SELECTED_CHECKBOX_STATE,
  SET_PAGE_SEARCH_TEXT,
  SET_PAGE_FILTER_VALUE,
  SET_ZERPA_TABLE_STATE,
  SET_PAGE_YEAR_VALUE,
  SET_PAGE_TYPE_VALUE,
  SET_PAGE_SELECTED_TAB,
  SET_PAGE_SHOW_DEACTIVATED,
  PageStateActionTypes,
  PageIdentifier,
  ZerpaState,
} from '../types';

export const setZerpaSelectedCheckbox = (
  pageId: PageIdentifier, payload: string[] | number[],
): PageStateActionTypes => ({
  type: SET_PAGE_SELECTED_CHECKBOX_STATE,
  pageId,
  payload,
});

export const setPageSearchText = (
  pageId: PageIdentifier, searchText: string,
): PageStateActionTypes => ({
  type: SET_PAGE_SEARCH_TEXT,
  pageId,
  payload: searchText,
});

export const setPageFilterValue = (
  pageId: PageIdentifier, filterValue: string,
): PageStateActionTypes => ({
  type: SET_PAGE_FILTER_VALUE,
  pageId,
  payload: filterValue,
});

export const setZerpaTableState = (
  pageId: PageIdentifier, zerpaState: ZerpaState,
): PageStateActionTypes => ({
  type: SET_ZERPA_TABLE_STATE,
  pageId,
  payload: zerpaState,
});

export const setYear = (
  pageId: PageIdentifier,
  payload: string,
): PageStateActionTypes => ({
  type: SET_PAGE_YEAR_VALUE,
  pageId,
  payload,
});

export const setType = (
  pageId: PageIdentifier,
  payload: number[],
): PageStateActionTypes => ({
  type: SET_PAGE_TYPE_VALUE,
  pageId,
  payload,
});

export const setSelectedTab = (
  pageId: PageIdentifier,
  payload: 'institute' | 'individual',
): PageStateActionTypes => ({
  type: SET_PAGE_SELECTED_TAB,
  pageId,
  payload,
});

export const setShowDeactivated = (
  pageId: PageIdentifier,
  payload: boolean,
): PageStateActionTypes => ({
  type: SET_PAGE_SHOW_DEACTIVATED,
  pageId,
  payload,
});
